import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";
import type BioExamResultsReceivedJournalEvent from "./bio-exam-results-received-journal-event";

export interface HprimPatient {
  lastName: string;
  firstName: string;
  birthday: string;
  socialSecurityNumber: string;
}

//---- Automatically generated, don't update this part ----

export default class ApicryptMessageReceivedJournalEvent extends JournalEvent {
  static type = "apicrypt-message-received-journal-event";

  @attr("string") declare apicryptUid: string;

  @attr("string") declare body: string;

  @attr("string") declare xdmBody: string;

  @attr() declare senders: string[];

  @attr("string") declare recipient: string;

  static validations(intl: IntlService) {
    return {
      apicryptUid: validatePresence({
        presence: true,
        description: intl.t(
          "validations.apicrypt-message-received-journal-event.apicrypt-uid"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.apicrypt-message-received-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("bio-exam-results-received-journal-event", {
    async: false,
    inverse: "apicryptMessageReceivedJournalEvents"
  })
  declare bioExamResultsReceivedJournalEvent: BioExamResultsReceivedJournalEvent;

  get decodedBody() {
    return window.atob(this.xdmBody || this.body);
  }

  get hprimPatient(): HprimPatient | undefined {
    const splittedHprim = this.decodedBody.split("\n");
    const birthdayString = splittedHprim[6]
      .trim()
      .split("/")[2]
      .concat(
        "-",
        splittedHprim[6].split("/")[1],
        "-",
        splittedHprim[6].split("/")[0]
      );

    return {
      lastName: splittedHprim[1].trim(),
      firstName: splittedHprim[2].trim(),
      birthday: birthdayString,
      socialSecurityNumber: splittedHprim[7].replace(/\s+/, "").trim()
    };
  }

  get escapedRawHprim() {
    return this.decodedBody
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "apicrypt-message-received-journal-event": ApicryptMessageReceivedJournalEvent;
  }
}
